import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import type { NotifyPermission } from '../types'

type BrowserExportNotificationProps = {
  open: boolean
  supported: boolean
  permission: NotifyPermission
  requesting: boolean
  error: string | null
  onEnable: () => void
}

const BrowserExportNotification = ({
  open,
  supported,
  permission,
  requesting,
  error,
  onEnable,
}: BrowserExportNotificationProps) => {
  if (!open) return null

  const canEnable = supported && permission !== 'granted' && !requesting

  return (
    <Box
      sx={{
        mt: 1,
        p: 1.5,
        borderRadius: 2,
        bgcolor: 'rgba(0,0,0,0.04)',
        border: '1px solid rgba(0,0,0,0.10)',
        textAlign: 'left',
      }}
    >
      <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
        Notifications
      </Typography>

      {!supported && (
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Non supporté sur ce navigateur.
        </Typography>
      )}

      {supported && (
        <>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            <strong
              style={{
                color: permission === 'granted' ? '#2e7d32' : '#ed6c02', // vert / orange MUI-ish
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              {permission === 'granted' ? '✅ Autorisation accordée' : '❌ Autorisation absente'}
            </strong>
          </Typography>

          {permission === 'granted' && (
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                mt: 0.5,
                opacity: 0.75,
              }}
            >
              Une notification sera envoyée à la fin de l’export.
            </Typography>
          )}

          {permission !== 'granted' && (
            <Button
              onClick={onEnable}
              size="small"
              variant="contained"
              sx={{ mt: 1 }}
              disabled={!canEnable}
            >
              {requesting ? 'Activation…' : 'Activer'}
            </Button>
          )}
        </>
      )}


      {error && (
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 1,
            color: 'error.main',
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  )
}

export default BrowserExportNotification
